import BudgetTable from '../screens/budget-table'

onDomLoad(function ($dom) {
  if ($dom.find('[data-behaviour="budget-table"]').length > 0) {
    window.BudgetTable = new BudgetTable(
      $dom.find('[data-behaviour="budget-table"]')
    )
  }
})
